export const content = ({ theme: { colors }, logo }) => ({
    backgroundColor: colors.bgGrey,

    boxSizing: 'border-box',

    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    paddingTop: '1.25rem',
    paddingBottom: '1.5rem',

    maxWidth: '18.5rem',

    marginTop: '-6rem',
    marginBottom: '1.625rem',
    marginRight: 0,

    position: 'relative',
    zIndex: 2,

    tablet: {
        maxWidth: '27.5rem',
        marginRight: '-1.25rem',
    },

    tabletLarge: {
        marginTop: logo ? '26rem' : '19rem',
    },

    '@media(min-width: 1083px)': {
        marginTop: '19rem',
    },
});

export const authorContainer = () => ({
    display: 'inline-block',
    verticalAlign: 'top',
});

export const extendRefferenceText = {
    text: () => ({
        fontSize: '0.8125rem',
        lineHeight: '1.125rem',

        tablet: {
            fontSize: '1rem',
            lineHeight: '1.625rem',
        },
    }),
};

export const logoContainer = () => ({
    display: 'inline',
    verticalAlign: 'top',

    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',

    tabletLarge: {
        width: '3.125rem',
        height: '1rem',
    },

    '@media(min-width: 375px)': {
        marginLeft: '-2rem',
    },
});

export const logo = () => ({
    width: '3.125rem',
    height: '1rem',

    verticalAlign: 'top',

    tabletLarge: {
        width: '3.125rem',
        height: '1rem',
    },
});

export const extendText = () => ({
    text: () => ({
        fontWeight: 900,
        lineHeight: 0.9,
        marginBottom: '0.1875rem',
    }),
});

export const extendPositionText = {
    text: ({ theme: { colors } }) => ({
        color: colors.lightGrey,
        fontStyle: 'italic',
        fontSize: '0.8125rem',

        tablet: {
            fontSize: '0.875rem',
        },
    }),
};
